import NewOrganization from "components/_Pages/templates/pages/NewOrganization";

export default function NewOrganizationPage() {
  return <NewOrganization.Aurora />;
}
